function getClientLocale() {
  if (typeof Intl !== 'undefined') {
    try {
      return Intl.NumberFormat().resolvedOptions().locale;
    } catch (err) {
      return navigator.languages && navigator.languages.length
        ? navigator.languages[0]
        : navigator.language;
    }
  }
}

const timeFormatter = (timezone) => {
  return new Intl.DateTimeFormat(getClientLocale(), {
    timeStyle: 'long',
    dateStyle: 'short',
    timeZone: timezone,
  });
};

const dateOnlyFormatter = (timezone) => {
  return new Intl.DateTimeFormat(getClientLocale(), {
    dateStyle: 'short',
    timeZone: timezone,
  });
};

export const getLocalTimeZone = () => {
  return new Intl.DateTimeFormat(getClientLocale()).resolvedOptions().timeZone;
};

export const getDateFormatFromImageJSON = (imageJson) => {
  if (imageJson?.main?.date_taken_milliseconds) {
    const datetimeTimestamp = imageJson?.main?.date_taken_milliseconds;
    let user_timezone = imageJson.main.user_timezone;
    const date = new Date(datetimeTimestamp);
    if (user_timezone === undefined || user_timezone === null) {
      user_timezone = 'UTC';
    }
    return timeFormatter(user_timezone).format(date);
  }
};

export const getDateTimeFromMillisecondsTZ = (dateInMilliSec, timezone) => {
  if (dateInMilliSec) {
    const date = new Date(dateInMilliSec);
    if (timezone === undefined || timezone === null) {
      timezone = 'UTC';
    }
    return timeFormatter(timezone).format(date);
  }
};

export const getDateWithTimeZone = (dateInMilliSec, timezone) => {
  if (dateInMilliSec) {
    const date = new Date(dateInMilliSec);
    if (timezone === undefined || timezone === null) {
      timezone = 'UTC';
    }
    return dateOnlyFormatter(timezone).format(date);
  }
};
